// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-modal {
  align-items: flex-start !important;
}
.location-modal .modal-container {
  margin-top: 100px !important;
  display: flex;
  padding: 24px;
  width: 327 !important;
  height: unset !important;
}
.location-modal .modal-header {
  width: 100% !important;
  padding: 0 !important;
}
.location-modal .modal-content {
  overflow: visible !important;
  padding: 0 !important;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

@media screen and (max-width: 650px) {
  .location-modal {
    align-items: flex-start !important;
  }
  .location-modal .modal-container {
    margin-top: 100px !important;
    display: flex;
    padding: 24px;
    width: 20 !important;
    height: unset !important;
  }
  .location-modal .modal-header {
    width: 100% !important;
    padding: 0 !important;
  }
  .location-modal .modal-content {
    overflow: visible !important;
    padding: 0 !important;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/landing-page/components/locationModal/style.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;AACF;AACE;EACE,4BAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,wBAAA;AACJ;AAEE;EACE,sBAAA;EACA,qBAAA;AAAJ;AAGE;EACE,4BAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;;AAKA;EAEE;IACE,kCAAA;EAHF;EAKE;IACE,4BAAA;IACA,aAAA;IACA,aAAA;IACA,oBAAA;IACA,wBAAA;EAHJ;EAME;IACE,sBAAA;IACA,qBAAA;EAJJ;EAOE;IACE,4BAAA;IACA,qBAAA;IACA,WAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EALJ;AACF","sourcesContent":[".location-modal {\n  align-items: flex-start !important;\n\n  .modal-container {\n    margin-top: 100px !important;\n    display: flex;\n    padding: 24px;\n    width: 327 !important;\n    height: unset !important;\n  }\n\n  .modal-header {\n    width: 100% !important;\n    padding: 0 !important;\n  }\n\n  .modal-content {\n    overflow: visible !important;\n    padding: 0 !important;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n}\n\n@media screen and (max-width: 650px)  {\n    \n  .location-modal {\n    align-items: flex-start !important;\n\n    .modal-container {\n      margin-top: 100px !important;\n      display: flex;\n      padding: 24px;\n      width: 20 !important;\n      height: unset !important;\n    }\n\n    .modal-header {\n      width: 100% !important;\n      padding: 0 !important;\n    }\n\n    .modal-content {\n      overflow: visible !important;\n      padding: 0 !important;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
